import { Route } from 'react-router-dom';
import About from './About';

export default [
  <Route path="/info/about" key="/info/about" exact component={About} />,
];
